import React, { FunctionComponent } from "react"
import s from "./Loader.less"

const Loader: FunctionComponent = () => {
  return (
    <div className={s.root}>
      <span className={s.spinner}></span>
    </div>
  )
}

export default Loader
